import { useState, useEffect } from 'react'
import { urls } from '../urls'
import { generateBatchPrintQueryParams } from '../utils/queryParams/batchPrint';
import { QueryRequestBody } from 'interfaces/common/QueryRequestBody';
import { transformBatchPrintData } from 'utils/queryTransactionsHelpers';
import { useTableStore, useUserStore } from 'state';
import { TableNames } from 'customEnums/TableNames';

enum BatchPrintOk {
    OK = "Successfully updated all the tcns confirmedate"
}

export const useBatchPrint = (
    pageSize: number,
    currentPage: number,
    searchParams: any
) => {

    const [mapped, setMappedData] = useState<any>([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false)
    const [countError, setError] = useState();
    const userConfig = useUserStore(state => state.userConfig)
    const currentPageName = useTableStore(state => state.pageName);

    const { userRole } = userConfig;;

    const url = urls.QUERY;

    const pagination = useTableStore(state => state.pagination)
    const { order, orderBy } = pagination[TableNames.BATCH_PRINTING]

    const handlePrintConfirm = async (selected, searchParams) => {
        return new Promise((resolve, reject) => {

            (async () => {
                const param = searchParams.find((param) => param.column === "transactionDate" || param.column === "lowerDate" || param.column === "upperDate")

                const queryParams = generateBatchPrintQueryParams(orderBy, param, searchParams)

                let queryDataRequest: QueryRequestBody = {
                    "queries": [
                        {
                            "queryParams": [
                                ...queryParams,
                                {
                                    "value": order,
                                    "name": "order"
                                }
                            ],
                            "limit": pageSize,
                            "offset": (currentPage - 1) * pageSize,
                            "queryName": process.env.REACT_APP_BATCHPRINT_UNPRINTED_QUERY!
                        }
                    ]
                }

                const body = {
                    inputTcns: selected
                }

                try {
                    const batchprintUrl = urls.BATCHPRINT;
                    let resp = await (await (fetch(`${process.env.NODE_ENV === "production" ? batchprintUrl : ""
                        }/batchprint/tcns-confirmdate`, {
                        method: 'POST',
                        body: JSON.stringify(body),
                        credentials: 'include'
                    }))).json()

                    console.log(`batch print flow  ${resp.message} === ${BatchPrintOk.OK}`, resp.message === BatchPrintOk.OK)
                    if (resp.message === BatchPrintOk.OK) {
                        await fetchUnprinted(queryDataRequest)
                        resolve(true)
                    } else {
                        console.log('Wrong Message');
                        reject()
                    }
                } catch (e: any) {
                    console.error('Error submmitinc tcns: ', e)
                    reject(e)
                }
            })()

        })

    }

    const fetchUnprinted = async (queryDataRequest: any) => {
        console.log('query batch print fetchUnprinted running')

        try {
            const batchPrintUrl: string = `${process.env.NODE_ENV === "production" ? url : ""}/query`;

            setLoading(true)

            const data = await (await fetch(batchPrintUrl, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(queryDataRequest)
            })).json();

            const { results } = data['queriesResults'][0];
            const transformedData = results.map((obj: any, index: number) => transformBatchPrintData(obj, index));
            console.log('batch print flow setMappedData: ', transformedData)
            setMappedData(transformedData);
            setTotalRecords(data['queriesResults'][0].fullCount);
            setLoading(false);

        } catch (err: any) {
            setError(err);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (orderBy === 'checkbox') return

        if (currentPageName !== 'batch-printing') {
            console.log('useBatchPrint: Not on batch-printing page, skipping query');
            return
        }

        console.log('batch print flow running useBatchPrint')
        const controller = new AbortController()

        const param = searchParams.find((param) => param.column === "transactionDate" || param.column === "lowerDate" || param.column === "upperDate")

        console.log('query batch print useEffect')

        const queryParams = generateBatchPrintQueryParams(orderBy, param, searchParams)

        let queryDataRequest: QueryRequestBody = {
            "queries": [
                {
                    "queryParams": [
                        ...queryParams,
                        {
                            "value": order,
                            "name": "order"
                        }
                    ],
                    "limit": pageSize,
                    "offset": (currentPage - 1) * pageSize,
                    "queryName": process.env.REACT_APP_BATCHPRINT_UNPRINTED_QUERY!
                }
            ]
        }


        setLoading(true);
        fetchUnprinted(queryDataRequest)

        return () => {
            controller.abort();
        }
    }, [
        currentPageName,
        url,
        order,
        orderBy,
        currentPage,
        pageSize,
        userRole,
        searchParams
    ])

    return { data: mapped, handlePrintConfirm, totalRecords, countError, loading }
}